import React from 'react';

import Unauthenticated from 'Components/Layouts/Unauthenticated';
import AuthLayout from 'Components/Layouts/AuthLayout';
import {FormHandler, Input, Select} from 'Components/Form';
import {Link} from 'Components/Utilities';

import Auth from 'Services/Api/Auth/Auth';
import GroupsApi from 'Services/Api/Groups/Groups';

import {translation} from 'Services/TranslationHelpers';
import DateTime from "luxon/src/datetime";

class Login extends React.Component {
    /**
     * @var state
     */
    state = {
        groupName: null,
        close_login: false
    };

    componentDidMount() {
        let date_now =  DateTime.local().toUTC();
        let close_date = DateTime.fromISO(process.env.MIX_CLOSE_SITE_DATE).toUTC();

        //Close site after date
        if(process.env.MIX_CLOSE_SITE_DATE) {
            this.setState ( {
                close_login: ( date_now.ts >= close_date.ts )
            } );
        }
    }

    /**
     * @method render
     * @return {JSX.Element}
     */
    render() {
        const {groupName, close_login} = this.state;
        const {form, handleInput, getFieldError, handleSubmit, working, alert} = this.props;

        // Set the column that the user will login with. Email if admin else set by config.
        let login_column = window.base.login_column;

        // Do not display the group selector by default.
        let display_group_selector = false;

        // If the login_column config is an array then it indicates that it depends on the user-group
        // so display the group-selector and set the login_column according to the selected group.
        if (typeof login_column === 'object') {
            display_group_selector = true;
            login_column = groupName ? login_column[groupName] : null;
        }

        return (
            <Unauthenticated>
                <AuthLayout
                    title={'Welcome'}
                    backLink={window.base.features.allow_password_resets ? "/password/request" : null}
                    backLinkText={translation('auth_frontend', 'forgot_your_password')}
                    submitText={translation('auth_frontend', 'login')}
                    onSubmit={(e) => handleSubmit(e, Auth.login)}
                    working={working}
                    alert={alert}
                    hideSubmit={(form?.admin_login || !close_login)}
                >
                    {!close_login &&
                        <>
                            <p className="font-bold mb-4 text-black text-center md:text-left">
                                Welcome to the Boots and No7 Beauty Company Autumn Leadership Meeting Registration Site.
                            </p>

                            <p className="font-light mb-12 text-black text-center md:text-left">
                                Please log in to enter the registration page.
                            </p>
                        </>
                    }

                    {close_login &&
                        <p className="font-bold mb-4 text-black text-center md:text-left">
                            Registration for the Boots and No7 Beauty Company Autumn Leadership Meeting has now closed.
                        </p>
                    }

                    {(form?.admin_login || !close_login) &&
                        <>
                            <Input
                                textColor={"text-black"}
                                label={translation('auth_frontend', login_column)}
                                type={login_column === "email" ? "email" : null}
                                value={form[login_column]}
                                onChange={v => handleInput(login_column, v)}
                            />

                            <Input
                                textColor={"text-black"}
                                label={translation('auth_frontend', 'password')}
                                type="password"
                                value={form.password}
                                onChange={v => handleInput('password', v)}
                            />
                        </>
                    }

                    {(window.base.login_column !== 'email' || close_login) &&
                        <p
                            className="text-sm text-black hover:underline cursor-pointer text-right mt-4"
                            onClick={() => handleInput('admin_login', !form?.admin_login)}
                        >
                        {form?.admin_login ?
                            'Return To Login' :
                            'Admin Login'}
                    </p>
                    }
                </AuthLayout>

                {window.base.features.allow_registrations &&
                    <p className="text-center mt-4">
                        <Link to="/register">
                            {translation('auth_frontend', 'register_here')}
                        </Link>
                    </p>
                }
            </Unauthenticated>
        );
    }
}

export default FormHandler(Login);
